const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const verified=r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED';

export function deriveMoleEvidence(bundle={}){
 const m=bundle?.secFinancials?.metrics||{};
 const fcf=N(m.freeCashFlowAnnual),opMargin=N(m.operatingMarginPct),cash=N(m.cashAndEquivalents),debt=N(m.totalDebt);
 const relationships=Array.isArray(bundle?.relationships)?bundle.relationships:[];
 const verifiedShares=relationships.filter(verified).map(r=>({name:r.counterparty_name||r.counterparty_ticker||'Counterparty',type:r.relationship_type||'RELATIONSHIP',share:N(r.share_estimate_pct)})).filter(r=>r.share!=null&&r.share>=0);
 const maxRelationship=verifiedShares.sort((a,b)=>b.share-a.share)[0]||null;
 const debtCashRatio=debt!=null&&cash!=null?(cash>0?debt/cash:debt>0?Infinity:0):null;
 const flags=[];let observed=0;

 if(fcf!=null){observed++;if(fcf<0)flags.push({code:'NEGATIVE_FCF',severity:'HIGH',value:fcf,note:'Latest annual SEC free cash flow is negative.'})}
 if(opMargin!=null){observed++;if(opMargin<0)flags.push({code:'NEGATIVE_OPERATING_MARGIN',severity:'MEDIUM',value:opMargin,note:'Latest annual SEC operating margin is negative.'})}
 if(debtCashRatio!=null){observed++;if(debtCashRatio>=2)flags.push({code:'DEBT_TO_CASH',severity:debtCashRatio>=3?'HIGH':'MEDIUM',value:debtCashRatio,note:'Reported debt is at least 2× reported cash and equivalents.'})}
 if(verifiedShares.length){observed++;if(maxRelationship.share>=30)flags.push({code:'RELATIONSHIP_CONCENTRATION',severity:maxRelationship.share>=50?'HIGH':'MEDIUM',value:maxRelationship.share,note:`Verified ${String(maxRelationship.type).toLowerCase()} relationship with ${maxRelationship.name} has a stored share estimate of ${maxRelationship.share}%.`})}

 let state='MISSING';
 if(observed){
  if(flags.length>=2)state='MULTIPLE_RISK_FLAGS';
  else if(flags.length===1)state='RISK_FLAG';
  else if(observed>=2)state='NO_CURRENT_FLAGS';
  else state='LIMITED_EVIDENCE';
 }

 return{
  status:state==='MISSING'?'MISSING':'EVIDENCE',
  state,
  flags,
  flagCount:flags.length,
  observedDimensions:observed,
  freeCashFlowAnnual:fcf,
  operatingMarginPct:opMargin,
  debtCashRatio:Number.isFinite(debtCashRatio)?debtCashRatio:debtCashRatio===Infinity?Infinity:null,
  maxRelationshipSharePct:maxRelationship?.share??null,
  maxRelationshipName:maxRelationship?.name??null,
  maxRelationshipType:maxRelationship?.type??null,
  note:'Mole surfaces specific risk flags from available verified evidence. NO_CURRENT_FLAGS means no flag crossed these documented thresholds; it does not prove that hidden risk is absent.'
 };
}
